import { eventHelper, UxIcon, UxIconEnum } from "@imaginelearning/mps-ux-component-library";
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import IEdgeUserProfileProps from "./edge-user-profile.props";
import "./edge-user-profile.scss";
import { logoutUser } from "../../helpers/user-session";
import useUser from "../../hooks/useuser";
import useGradeRange from "hooks/usegraderange";

const CustomToggle = React.forwardRef((props: any, ref: any) => (
  <div
    {...props}
    {...eventHelper(props.onClick, { tabIndex: 0 })}
    ref={ref}
    data-testid="student-app-header-menu-button"
    className="custom-dropdown-toggle cursor-pointer mx-3 text-white fw-bold"
  >
    <span role="region" className="me-2">
      {props.children}
    </span>
    <UxIcon {...{ icon: UxIconEnum.CHEVRON_DOWN }} />
  </div>
));

function EdgeUserProfile(props: IEdgeUserProfileProps) {
  const { t } = useTranslation();
  const { is9to12 } = useGradeRange();
  const { user } = useUser();
  const dropDownItems = [
    {
      label: "Logout",
      onClick: () => logoutUser(user)
    }
  ];
  if (is9to12) {
    dropDownItems.unshift({
      label: "My Stuff",
      onClick: () => props.handleNavigation("/mystuff")
    });
    dropDownItems.unshift({
      label: "My Progress",
      onClick: () => props.handleNavigation("/myprogress")
    });
  }

  return (
    <div data-private className="edge-user-profile-container">
      <Dropdown title={props.userFirstname}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
          {props.userFirstname}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {dropDownItems.map((item, index: number) => (
            <Dropdown.Item key={index} onClick={item.onClick}>
              {t(item.label)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default EdgeUserProfile;
